// extracted by mini-css-extract-plugin
module.exports = {"innerWrapper":"nE-z","tooltipWrapper":"oE-z","icon":"pE-z","tooltip":"qE-z","content":"rE-z"};